<template>
  <div>
    <div
      ref="ModalRestock"
      id="ModalRestock"
      aria-labelledby="ModalRestock"
      class="modal modal-right fade footer-fix"
      data-backdrop="static"
      role="dialog"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" ref="section">
          <div class="modal-header bg-dark">
            <h6 class="modal-title">
              <span>
                {{ $t("Manage Product Stock") }}
              </span>
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="closeModal()"
            >
              ×
            </button>
          </div>

          <div class="modal-body p-0 pb-5 px-0" v-show="onload">
            <div class="content">
              <placeholder-content is-load="true" />
            </div>
          </div>

          <div v-show="!showRestockOrder">
            <div v-show="!onload">
              <div v-show="!hasPermission" class="modal-body p-0 pb-5 px-0">
                <access-denied />
              </div>
              <div v-show="hasPermission">
                <div class="modal-body p-0 pb-5 px-0">
                  <div class="px-0">
                    <legend
                      class="font-size-lg mb-0 px-3 py-2"
                      style="margin-bottom: 15px; color: black;"
                    >
                      <i class="fa-solid fa-circle-info mr-1" />
                      {{ $t("Order Information") }}
                    </legend>
                  </div>
                  <div class="content">
                    <div
                      v-if="totalRestockOrders > 0"
                      class="alert alert-warning-custom text-warning">
                      <i
                        class="fa-circle-exclamation fa-sharp fa-solid pr-1"
                      ></i>
                      <span>
                        {{ $t("_Combine.Found") }}
                        {{ totalRestockOrders }}
                        {{
                          $t(
                            "product has been shipped without stock movement. If you want to record the movement, please click “Create Adjustment”."
                          )
                        }}
                      </span>
                    </div>

                    <!-- table-product -->

                    <div class="border border-bottom-0 rounded">
                      <!-- table-warehouse -->
                      <div :class="['datatable-scroll', loadingTable]">
                        <div
                          class="table-responsive mt-0 main-scroll data-nowrap rounded"
                        >
                          <div class="vuetable-wrapper ui basic segment">
                            <vuetable
                              :no-data-template="$t('No Data Available')"
                              :class="['min-w-2048']"
                              class="dataTable thead-bg-fafafa table-hover"
                              ref="vuetable"
                              :data-manager="dataManager"
                              :api-mode="false"
                              :append-params="paramsQuery"
                              :fields="table.fields"
                              :css="{ sortableIcon: 'grey sort icon' }"
                              @vuetable:pagination-data="onPaginationData"
                              @vuetable:loaded="vuetableLoaded"
                              @vuetable:loading="vuetableLoading"
                              data-path="data"
                              pagination-path=""
                              @vuetable:initialized="onInitialized"
                              :sort-order="table.sortOrder"
                              @vuetable:checkbox-toggled-all="toggleAllCheckboxes"
                              @vuetable:checkbox-toggled="toggleCheckboxs"
                            >
                              <div slot="sales_channel_logo" slot-scope="props">
                                <ChannelsLogoComponent
                                  :product-id="props.rowData.id"
                                  :channels-name="props.rowData.channel_name"
                                  :channels-image-url="
                                  props.rowData.channel_logo
                                  "
                                />
                              </div>
                              <div slot="image" slot-scope="props">
                                <ProductImageComponent
                                  :product-id="props.rowData.id"
                                  :product-image-url="props.rowData.image"
                                  :pop-up-image="false"
                                />
                              </div>
                              <div slot="name" slot-scope="props">
                                <router-link
                                  :to="{
                                    name: 't.a.products',
                                    query: { productId: props.rowData.id }
                                  }"
                                  target="_blank"
                                >
                                  <ProductNameComponent
                                    v-if="
                                      props.rowData.wms_link_id != '' ||
                                        props.rowData.wms_link_id != null
                                    "
                                    :product-name="props.rowData.name"
                                    :product-sku="props.rowData.sku"
                                  />
                                  <ProductNameComponent
                                    v-else
                                    :product-name="props.rowData.name"
                                    :product-sku="props.rowData.sku"
                                    :product-link="props.rowData.wms_link_id"
                                  />
                                </router-link>
                              </div>

                              <div slot="quantity" slot-scope="props">
                                <span>{{
                                  props.rowData.quantity | formatNumberNotZero
                                }}</span>
                              </div>

                              <div slot="action" slot-scope="props">
                                <div class="list-icons">

                                  <a
                                    href="#"
                                    class="list-icons-item"
                                    data-toggle="dropdown"
                                  >
                                    <i class="icon-menu9" />
                                  </a>
                                  <div class="dropdown-menu dropdown-restock dropdown-menu-right">
                                    <a
                                      href="javascript:void(0);"
                                      class="dropdown-item"
                                      @click="restockOrder(props.rowData.id,props.rowData)"
                                    >
                                      <i class="fa-1x fa-solid fa-eye mr-2" />
                                      {{ $t("View") }}
                                    </a>

                                    <a
                                      href="javascript:void(0)"
                                      class="dropdown-item"
                                      @click="validateRestock([props.rowData])"
                                    >
                                      <i class="fa-solid fa-plus-minus mr-2" />
                                      {{ $t("Create Quantity Adjustment") }}
                                    </a>

                                    <!-- <a
                                      href="javascript:void(0)"
                                      class="dropdown-item"
                                      @click="ignoreItem({product_ids: [props.rowData.id],order_ids: props.rowData.sales_order.map(el => el.order_id)})"
                                    >
                                      <i class="fa-solid fa-circle-x mr-2" />
                                      {{ $t("Ignore") }}
                                    </a> -->
                                  </div>

                                </div>
                              </div>
                            </vuetable>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="datatable-footer">
                      <vuetable-pagination-info
                        class="dataTables_info"
                        ref="paginationInfo"
                        style="color: #333333;"
                        :no-data-template="$t('No relevant data')"
                        :info-template="
                          $t('Displaying {from} to {to} of {total} items')
                        "
                      />

                      <div
                        class="dataTables_paginate paging_simple_numbers mb-0"
                      >
                        <vuetable-pagination
                          ref="pagination"
                          pagination-path="pagination"
                          style="color: #333333;"
                          @vuetable-pagination:change-page="onChangePage"
                        />
                      </div>
                    </div>
                    <!-- table-product -->
                  </div>
                </div>
                <div class="card-footer fixed-bottom bg-light text-center">
                  <div v-if="productSelected.size > 0" class="btn-group">
                    <button
                      type="button"
                      class="btn btn-primary dropdown-toggle mr-2"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa-solid fa-ellipsis fa-1x mr-1" />
                      {{ $t("More Action") }}
                    </button>

                    <div
                      class="dropdown-menu dropright dropdown-restock-bulk-action"
                    >
                      <a
                        href="javascript:void(0)"
                        class="dropdown-item"
                        @click="validateRestock"
                      >
                        <i class="fa-solid fa-plus-minus mr-2" />
                        {{ $t("Create Quantity Adjustment") }}
                      </a>

                      <!-- <a
                        href="javascript:void(0)"
                        class="dropdown-item"
                        @click="ignoreItem(ignoreSelected)"
                      >
                        <i class="fa-solid fa-circle-x mr-2"></i>
                        {{ $t("Ignore") }}
                      </a> -->
                    </div>
                  </div>

                  <button
                    @click="closeModal()"
                    type="button"
                    class="btn btn-light"
                  >
                    {{ $t("Cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showRestockOrder">
            <restock-order
              :product-name="productName"
              :ordertData="orderData"
            />
          </div>
        </div>
        <!-- check showPlaceholder -->
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service";
import FieldsDef from "../assets/FieldsRestockItem";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import Vuetable from "vuetable-2";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import RestockOrder from "./RestockOrder";
import ProductNameComponent from "@/components/tenancy/center/ProductNameComponent.vue";
import ProductImageComponent from "@/components/tenancy/center/ProductImageComponent.vue";
import ChannelsLogoComponent from "@/components/tenancy/center/ChannelsLogoComponent.vue";

import numeral from "numeral";

export default {
  name: "ModalRestock",
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PlaceholderContent,
    AccessDenied,
    RestockOrder,
    ProductNameComponent,
    ProductImageComponent,
    ChannelsLogoComponent
  },
  props: {
    numberOfProduct: {
      type: [Number],
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {
      showOrder: true,
      onload: true,
      loadingTable: "",
      showRestockOrder: false,
      hasPermission: false,
      loadingWarehouse: false,
      selectedBulk: [],
      filter: {
        limit: 10,
        page: 1
      },
      table: {
        fields: FieldsDef,
      },
      paramsQuery: {
        limit: 10,
        page: 1
      },
      listAction: [
        {
          id: 1,
          slug: "Create Quantity Adjustment",
          name: "Create Quantity Adjustment",
          icon: "fa-solid fa-plus-minus mr-2"
        }
      ],
      isActive: true,
      warehouse: [],
      typeName: "",
      listData: [],
      totalRestockOrders: 0,
      orderData: [],
      productsList: [],
      adjusmentData: [],
      ignoreSelected: {},
      productSelected: new Set(),
      productName: "",
      products: [],
      isRestockValidateModal: false
    };
  },
  watch: {},
  filters: {
    formatNumberNotZero: function(value) {
      return numeral(value).format("0,0");
    }
  },
  mounted() {
  },
  methods: {
    encodeLink(data) {
      return btoa(data);
    },
    closeModal() {
      $("#ModalRestock").modal("hide");
      this.$parent.isRestockModal = false;
    },
    validateRestock(products = []) {
      this.closeModal();
      $("#ModalRestock").on("hidden.bs.modal", e => {
        this.$parent.isRestockValidateModal = true;
        this.$parent.products = products.length
          ? products
          : Array.from(this.productSelected);
      });
    },
    setActive(name) {
      this.typeName = name;
      this.isActive = false;
      this.$nextTick(() => {
        this.isActive = true;
      });
    },
    groupedData(data) {
      return data.reduce((result, item) => {
        const groupName = item.warehouse_name;
        if (!result[groupName]) {
          result[groupName] = [];
        }
        result[groupName].push(item);
        return result;
      }, {});
    },

    async setParams(filter, page = 0) {
      this.loadingTable = "loading";
      let self = this;

      if (page) {
        this.filter.page = page;
        this.$refs.vuetable.currentPage = filter.page;
      } else {
        this.filter.page = this.$refs.vuetable.currentPage;
      }

      this.paramsQuery.limit = this.filter["limit"];
      this.paramsQuery.page = this.filter["page"];
      this.paramsQuery.viewpoint = this.filter["viewpoint"];

      let queryString = "";
      if (this.paramsQuery) {
        queryString += "?" + $.param(this.paramsQuery);
      }
      try {
        let getList = await Api.Inventory.getProductLists(queryString);

        this.listData = getList.data.data;
        this.totalRestockOrders = getList.data.meta.total;
        let data = self.$storeIndex.mutations.vueTableFormatJson(getList);
        self.$refs.vuetable.setData(data);

        this.onload = false;
        this.hasPermission = true;
      } catch (e) {
        this.hasPermission = false;

        console.log("catch");
        console.log(e);
      }
      this.loadingTable = "";
    },
    dataManager(sortOrder, pagination) {
      if (sortOrder.length > 0) {
        this.filter.sort = sortOrder
          .map(item => `${item.sortField}|${item.direction}`)
          .join(",");
      }
      this.setParams(this.filter);
    },
    setPerPage(perPage) {
      this.paramsQuery.page = 1;
      this.$refs.vuetable.currentPage = 1;
      this.filter.limit = perPage;
      this.setParams(this.filter);
    },
    onChangePage(page) {
      this.paramsQuery.page = page;
      this.$refs.vuetable.changePage(page);
    },
    vuetableLoaded() {
      this.loading = "";
    },
    vuetableLoading() {
      this.loading = "loading";
    },
    onPaginationData(tablePagination) {
      this.$refs.pagination.setPaginationData(tablePagination);
      this.$refs.paginationInfo.setPaginationData(tablePagination);
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter(field => field.togglable);
    },
    toggleCheckboxs(event, dataItem) {
      this.setSelectBulk(this.$refs.vuetable);
    },
    toggleAllCheckboxes(event) {
      this.setSelectBulk(this.$refs.vuetable);
    },
    async setSelectBulk(vuetable) {
      this.productSelected = new Set();
      vuetable.tableData.forEach((item, index) => {
        if (vuetable.selectedTo.includes(item.id)) {
          this.productSelected.add(item);
        }
      });
      await this.mapDataProducts(this.productSelected);
    },
    async mapDataProducts(products) {
      this.selectedBulk = [];
      let productIds = [];
      let orderIds = [];
      let productSets = [];
      for (let item of products) {
        if (
          item.product_type_id == 3 ||
          (item.product_type_id == 1 && item.link_id != null)
        ) {
          for (let salesOrder of item.sales_order) {
            const orderItem = salesOrder.items.find(
              order => order.product_id == item.id
            );
            if (orderItem && orderItem.set_items.length) {
              for (let setItem of orderItem.set_items) {
                let existingItem = productSets.find(
                  ps => ps.product_id === setItem.product_id
                );
                if (existingItem) {
                  existingItem.quantity += setItem.quantity;
                } else {
                  productSets.push({ ...setItem, quantity: setItem.quantity });
                }
              }
            }
          }
        }
        productIds.push(item.id);
        orderIds.push(item.sales_order.map(el => el.order_id));
      }
      this.ignoreSelected = {
        product_ids: productIds,
        order_ids: orderIds.flat()
      };
    },
    ignoreItem(items) {
      let obj = {
        product_ids: [...new Set(items.product_ids)],
        order_ids: [...new Set(items.order_ids)]
      };
      let self = this;
      this.$swal.fire({
        title: this.$t("Ignore Quantity Adjustment") + " ?",
        iconHtml:
          '<i class="fa-light fa-circle-exclamation" style="font-weight:300; font-size:6rem;"></i>',
        iconColor: "#FF7043",
        html: `<div class="row mr-2 ml-2">
              <div class="col-12 bbbb-soft-pink">
                ${this.$t(
                  "Will be remove from product adjustment. You cannot undo this process."
                )}
              </div>
            </div>`,
        showCancelButton: true,
        reverseButtons: false,
        confirmButtonText:
          '<i class="fa-solid fa-check-circle mr-2"></i>' + this.$t("Confirm"),
        cancelButtonText: this.$t("Cancel"),
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-light",
          loader: "custom-loader"
        },
        loaderHtml: '<div class="spinner-border text-primary"></div>',
        focusConfirm: false,
        showLoaderOnConfirm: true,
        preConfirm: async function() {
          return await Api.Inventory.ignoreProducts(obj)
            .then(response => {
              if (response.status == 200) {
                self.$toastr.s(
                  self.$t("Ignore Quantity Adjustment Success."),
                  "<span class='fa-solid fa-circle-check mr-2'></span>" +
                    self.$t("Success")
                );
                // if (type == 'order') {
                //   console.log('if order');
                //   this.showRestockOrder = false
                //   this.isRestockModal = true;
                // }
                self.setParams();
                self.$store.dispatch("inventory/refreshAlertRestock", true);
              }
            })
            .catch(e => {
              switch (e.response.status) {
                case 403:
                  $("#ModalRestock").modal("hide");
                  self.$swal({
                    icon: false,
                    iconColor: "#FF7043",
                    title: self.$t("Access Denied"),
                    html:
                      self.$t("You do not have permission to access this page.") +
                      "<br/>" +
                      self.$t(
                        "If you feel this is a mistake, contact your admin."
                      ),
                    showCancelButton: false,
                    confirmButtonText:
                      '<i class="fa-solid fa-thumbs-up mr-1"></i> ' +
                      self.$t("OK"),

                    imageUrl: require("@/assets/images/activities/icon-access-denied.png"),
                    buttonsStyling: false,
                    customClass: {
                      confirmButton: "btn btn-primary mr-2",
                      cancelButton: "btn btn-light"
                    },
                    focusConfirm: false,
                    showLoaderOnConfirm: true,
                    popup: "validation-access-denied"
                  });
                break;

                case 400:
                  self.$toastr.e(
                    self.$t("Ignore Quantity Adjustment Failed."),
                    "<span class='icon-blocked'></span>" + self.$t("Error")
                  );
                break;

                default:
                  self.$toastr.e(
                    self.$t("Something went wrong. Please try again."),
                    "<span class='icon-blocked'></span>" + self.$t("Error")
                  );
                break;
              }
            });
        }
      });
    },
    restockOrder(id, items) {
      this.productName = items.name;
      this.orderData = items;
      this.mapDataProducts([items]);
      this.showRestockOrder = true;
    }
  }
};
(function () {
  // hold onto the drop down menu
  var dropdownMenu;

  // and when you show it, move it to the body
  $(window).on('show.bs.dropdown', function (e) {

  // grab the menu
  dropdownMenu = $(e.target).find('.dropdown-restock');

  // detach it and append it to the body
  $('.modal').append(dropdownMenu.detach());

  // grab the new offset position
  var eOffset = $(e.target).offset();

  // make sure to place it where it would normally go (this could be improved)
  dropdownMenu.css({
      'display': 'block',
          'top': eOffset.top + $(e.target).outerHeight(),
          'left': eOffset.left
      });
  });

  // and when you hide it, reattach the drop down, and hide it normally
  $(window).on('hide.bs.dropdown', function (e) {
      $(e.target).append(dropdownMenu.detach());
      dropdownMenu.hide();
  });
})();
</script>

<style scope>
.vuetable-body-wrapper {
  border-top: 0px solid #dddddd;
}
.dropdown-restock {
  width: 230px !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/restock/ModalRestock.vue